import { Text } from 'components/v2/Typography/Text';
import styled from 'styled-components';

export const Name = styled(Text)`
  display: flex;
  gap: 8px;
  align-items: center;
`;
